import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import EditIcon from 'components/ReusableComponents/Icons/Edit'
import Trash from 'components/ReusableComponents/Icons/Trash'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useInternalAdmin } from 'hooks'
import useLocalStorage from 'hooks/useLocalStorageState'
import { useState } from 'react'

import styles from './ComposeTemplates.module.scss'

const ComposeTemplates = ({ setComposeValue }) => {
  const isInternalAdmin = useInternalAdmin()

  const [isAddTemplateDialogVisible, setisAddTemplateDialogVisible] = useState()

  const [templates, setTemplates] = useLocalStorage('composeTemplates', {})

  const [activeTemplateName, setActiveTemplateName] = useState('')
  const [activeTemplateContent, setActiveTemplateContent] = useState('')

  function saveTemplate() {
    if (activeTemplateName && activeTemplateContent) {
      const newTemplates = { ...templates }
      newTemplates[activeTemplateName] = activeTemplateContent
      setTemplates(newTemplates)
    }
    setisAddTemplateDialogVisible(false)
  }

  function deleteTemplate(key) {
    setTemplates(prevTemplates => {
      const newTemplates = { ...prevTemplates }
      delete newTemplates[key]
      return newTemplates
    })
  }

  function editTemplate(key) {
    setActiveTemplateName(key)
    setActiveTemplateContent(templates[key])
    setisAddTemplateDialogVisible(true)
  }

  function openAddTemplateDialog() {
    setisAddTemplateDialogVisible(true)
    setActiveTemplateContent('')
    setActiveTemplateName('')
  }

  if (!isInternalAdmin) {
    return null
  }

  return (
    <div>
      {isAddTemplateDialogVisible && (
        <ConfirmationDialog
          title="Edit template"
          onClose={() => setisAddTemplateDialogVisible(false)}
          positiveMessage="Save template"
          onConfirm={saveTemplate}
        >
          <div className={styles.templateForm}>
            <TextInput
              label="Template name"
              type="text"
              placeholder="Template name"
              value={activeTemplateName}
              onChange={e => setActiveTemplateName(e.target.value)}
            />
            <div className={styles.textAreaHolder}>
              <p className={styles.formLabel}>Template content</p>
              <textarea
                className={styles.textArea}
                placeholder="Template content"
                value={activeTemplateContent}
                onChange={e => setActiveTemplateContent(e.target.value)}
              />
            </div>
          </div>
        </ConfirmationDialog>
      )}
      <div className={styles.buttons}>
        <button
          className={styles.addTemplateButton}
          onClick={() => openAddTemplateDialog()}
        >
          Add a template
        </button>
        {Object.keys(templates).map(key => (
          <div key={key} className={styles.templateButton}>
            <button
              className={styles.templateButtonItself}
              onClick={() => setComposeValue(templates[key])}
            >
              {key}
            </button>
            <button className={styles.editButton} onClick={() => editTemplate(key)}>
              <EditIcon />
            </button>
            <button className={styles.deleteButton} onClick={() => deleteTemplate(key)}>
              <Trash />
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ComposeTemplates
